import credentials from "../config/credentials";

// Fallback only. The live figure comes from /hpi-pricing/ so the homepage can
// never advertise a price the checkout disagrees with.
export const DEFAULT_CHECK_PRICE = 4.95;

export const formatPrice = price => `£${Number(price).toFixed(2)}`;

export const fetchCheckPrice = () =>
  fetch(`${credentials.API_URL}/hpi-pricing/`)
    .then(response => response.json())
    .then(data => (data && data.price ? Number(data.price) : DEFAULT_CHECK_PRICE))
    .catch(() => DEFAULT_CHECK_PRICE);
